<script setup lang="ts">
import Search from '~/components/Profile/Preview/Search.vue'
import type { Profile } from '~/types/profile'
const { $navigate } = useNuxtApp()

interface Props {
	user: Profile
	theme: 'search'
	isLoading?: boolean
	emitResult?: boolean
	showTypeTag?: boolean
	closeOnSelect?: boolean
}

const props = defineProps<Props>()
const emits = defineEmits(['selected', 'close'])

function clicked() {
	if (props.emitResult) {
		emits('selected', props.user)

		if(props.closeOnSelect){
			emits('close')
		}

	} else {

		if(props.closeOnSelect){
			emits('close')
		}

		$navigate(`/profile/${props.user.username}`)
	}
}

</script>

<template>
	<Search v-if="theme === 'search'" :user="user" :showTypeTag="showTypeTag" @selected="clicked"/>

</template>
